import React from "react"
import useStore from "../../utils/useStore"

const ImageComponent = React.memo(({ item, isFullScreen }) => {
    const selects = useStore((state) => state.selects)
    const selected = selects?.find((e) => e === item?.id)
    const editElements = useStore((state) => state.editElements)
    const addSelects = useStore((state) => state.addSelects)
    const setClickedPosition = useStore((state) => state.setClickedPosition)
    const setDragging = useStore((state) => state.setDragging)
    const dragging = useStore((state) => state.dragging)
    const setResizing = useStore((state) => state.setResizing)
    const resizing = useStore((state) => state.resizing)
    const editing = useStore((state) => state.editing)
    const setEditing = useStore((state) => state.setEditing)

    const onMouseDown = (event) => {
        window.getSelection().removeAllRanges()
        if (selected) {
            //selects?.length > 1 || 
        } else if (event?.shiftKey) {
            addSelects(item?.id, true)
        } else {
            addSelects(item?.id)
        }
        editElements("prevPosition", { x: item?.currPosition?.x, y: item?.currPosition?.y }, item?.id)
        editElements("preHeight", item?.style?.height, item?.id)
        editElements("preWidth", item?.style?.width, item?.id)
        setClickedPosition({ x: event.clientX, y: event.clientY })
        if (!selected && editing) {
            setEditing(false)
            setTimeout(() => {
                setDragging(true)
            }, 50);
        } else if (!selected) {
            setDragging(true)
        }
    }

    const onMouseHandleDown = (event, cursor, side) => {
        event.stopPropagation()
        window.getSelection().removeAllRanges()
        editElements("prevPosition", { x: item?.currPosition?.x, y: item?.currPosition?.y }, item?.id)
        editElements("preWidth", item?.style?.width, item?.id)
        editElements("preHeight", item?.style?.height, item?.id)
        setResizing({ cursor: cursor, side })
        setClickedPosition({ x: event.clientX, y: event.clientY })
    }

    return (
        <div className={!isFullScreen && selected ? 'Presentation_Image_Select Presentation_Image_Selected' : 'Presentation_Image_Select'} style={{ position: "absolute", transform: `translate(${item?.currPosition?.x}px, ${item?.currPosition?.y}px)`, pointerEvents: isFullScreen ? "none" : "", cursor: resizing ? resizing?.cursor : dragging ? "move" : "default", userSelect: "none" }} onMouseDown={onMouseDown} onClick={(event) => {
            event.stopPropagation()
            if (!selected) {
                addSelects(item?.id)
            }
        }}>
            <img alt='' draggable={false} src={item?.value} style={{ ...item?.style }} />
            {selected && !dragging && !isFullScreen ?
                <>
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_LT' onMouseDown={(e) => onMouseHandleDown(e, 'nwse-resize', "top-left")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_LB' onMouseDown={(e) => onMouseHandleDown(e, 'nesw-resize', "bottom-left")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_RT' onMouseDown={(e) => onMouseHandleDown(e, 'nesw-resize', "top-right")} />
                    <div className='Presentation_Image_Handle Presentation_Image_Handle_RB' onMouseDown={(e) => onMouseHandleDown(e, 'nwse-resize', "bottom-right")} />
                </>
                : null}
        </div>
    )
})

export default ImageComponent;